import { EVENT_STATUS } from '@hedepy/common/enums/EVENT'
import type { Event } from '@hedepy/common/schemas/modules/event/event'

import type { TherapistType } from '../../types/TherapistStateType'
import { rewriteTherapistCredentials } from '../../utilities/selectorHelpers'
import sortArray from '../../utilities/sort'
import createResultCheckingSelector from '../memoize'
import type { ReduxState } from '../reducers'

const therapistsFilter = (state: ReduxState, { serviceId }: { serviceId?: number }) =>
  (state.client.therapists ?? []).map((therapist) => rewriteTherapistCredentials(therapist, serviceId))

const eventsFilter = (state: ReduxState) => state.client.appointments ?? {}

export const therapistObjectSelector = createResultCheckingSelector([therapistsFilter], (therapists) =>
  therapists.reduce<{ [key: number]: TherapistType }>((acc, therapist: TherapistType) => {
    acc[therapist.therapistId] = therapist
    return acc
  }, {}),
)

export const prebookedEventsSelector = createResultCheckingSelector([eventsFilter], (eventsByTherapistId): Event[] => {
  const therapistIds = Object.keys(eventsByTherapistId) as unknown as (keyof typeof eventsByTherapistId)[]

  // having prebookings from more than one therapist is an edge case
  // the UI needs events from just one therapist, though so any is fine
  const therapistId = therapistIds.find((therapistId) =>
    eventsByTherapistId[therapistId]?.find((event) => event.status === EVENT_STATUS.PRE_BOOKING),
  )

  const prebookedEvents = therapistId
    ? (eventsByTherapistId[therapistId]?.filter((event) => event.status === EVENT_STATUS.PRE_BOOKING) ?? [])
    : []

  return sortArray(prebookedEvents, [{ value: 'startDate' }])
})
